module.exports = __webpack_public_path__ + "media/promo/panasonic/images/icons/i-1-29d2fdbff3b5bca8386b52ec7345ba22.svg";